import { render, staticRenderFns } from "./ExportWizardCard.vue?vue&type=template&id=48926822&scoped=true&"
import script from "./ExportWizardCard.vue?vue&type=script&lang=js&"
export * from "./ExportWizardCard.vue?vue&type=script&lang=js&"
import style0 from "./ExportWizardCard.vue?vue&type=style&index=0&id=48926822&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48926822",
  null
  
)

export default component.exports